module.exports = __webpack_public_path__ + "static/media/userProfile.867de0ab.svg";